module.exports = __webpack_public_path__ + "img/logo.57cbb138.png";